export enum CouponType {
  ForProducts = 1,
  ForServices = 2,
}
